import type { Section, SubmissionSource, SubmissionStatus } from './types';

// ---------------------------------------------------------------------------
// Section ordering — drives both the stepper UI and progress calculation
// ---------------------------------------------------------------------------

export const SECTION_ORDER: Section[] = [
  'business_info',
  'contact',
  'industry',
  'coverage',
  'operations',
  'employees',
  'subcontractors',
  'vehicles',
  'claims',
  'loss_history',
  'property',
  'professional',
  'cyber',
  'management_liability',
  'supplement',
  'state_specific',
  'documents',
  'review',
];

export const SECTION_LABELS: Record<Section, string> = {
  business_info: 'Business Information',
  contact: 'Contact Details',
  industry: 'Industry & Classification',
  coverage: 'Coverage Selection',
  operations: 'Operations',
  employees: 'Employees & Payroll',
  subcontractors: 'Subcontractors',
  vehicles: 'Vehicles',
  claims: 'Claims History',
  loss_history: 'Loss History',
  property: 'Property',
  professional: 'Professional Liability',
  cyber: 'Cyber Liability',
  management_liability: 'Management Liability',
  supplement: 'Industry Supplement',
  state_specific: 'State-Specific',
  documents: 'Documents',
  review: 'Review & Submit',
};

// ---------------------------------------------------------------------------
// Submission statuses
// ---------------------------------------------------------------------------

export const SUBMISSION_STATUSES: SubmissionStatus[] = [
  'draft',
  'intake',
  'qualifying',
  'quoting',
  'quoted',
  'binding',
  'bound',
  'issued',
  'declined',
  'lost',
  'expired',
];

export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  draft: 'Draft',
  intake: 'Intake',
  qualifying: 'Qualifying',
  quoting: 'Quoting',
  quoted: 'Quoted',
  binding: 'Binding',
  bound: 'Bound',
  issued: 'Issued',
  declined: 'Declined',
  lost: 'Lost',
  expired: 'Expired',
};

// ---------------------------------------------------------------------------
// Submission sources
// ---------------------------------------------------------------------------

export const SUBMISSION_SOURCES: SubmissionSource[] = [
  'web_form',
  'agent_portal',
  'api',
  'email',
  'phone',
  'referral',
  'renewal',
];

export const SUBMISSION_SOURCE_LABELS: Record<SubmissionSource, string> = {
  web_form: 'Web Form',
  agent_portal: 'Agent Portal',
  api: 'API',
  email: 'Email',
  phone: 'Phone',
  referral: 'Referral',
  renewal: 'Renewal',
};

// ---------------------------------------------------------------------------
// Status transitions — which status can transition to which statuses
// ---------------------------------------------------------------------------

export const STATUS_TRANSITIONS: Record<SubmissionStatus, SubmissionStatus[]> = {
  draft: ['intake'],
  intake: ['qualifying', 'declined'],
  qualifying: ['quoting', 'declined', 'lost'],
  quoting: ['quoted', 'declined', 'lost'],
  quoted: ['binding', 'declined', 'lost', 'expired'],
  binding: ['bound', 'declined', 'lost'],
  bound: ['issued'],
  issued: [],
  declined: ['intake'], // allow re-opening
  lost: ['intake'], // allow re-opening
  expired: ['intake'], // allow re-opening
};
